(function () {
    'use strict';
    var controllerId = 'cndPCorso2A';
    angular.module('app').controller(controllerId, ['common', '$scope', '$rootScope', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', '_', 'commonAttach', fn_cndPCorso2A]);

    function fn_cndPCorso2A(common, $scope, $rootScope, bDialog, $routeParams, modal, datacontext, sectionMenu, _, commonAttach) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.title = 'Percorsi Formativi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "CNDCorso"; //Utilizzato per pannello authorization
        vm.authorization = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.confirm = {};
        vm.corsoMod = {};

        vm.pageWizard = 1;
        vm.pageMaxWizard = 5;
        vm.lastPageWizard = vm.pageWizard;
        vm.pageWizardTitle = [];
        vm.setPageWizard = setPageWizard;
        vm.wizardCompleted = false;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.bMaxOre = true;

        //Elenco per Ordinamento

        vm.list = {};

        vm.getRecord = getRecord;
        //vm.getAuthorization = getAuthorization;
        vm.getListAttach = getListAttach;
        vm.disableCompleted = true;
        vm.changeStateAttach = commonAttach.changeStateAttach;
        vm.extractCADESFile = commonAttach.extractCADESFile;
        vm.extractVerifySignInfo = commonAttach.extractVerifySignInfo;
        vm.safeDownload = commonAttach.safeDownload;

        //Elenchi dettaglio
        vm.list.attach = [];
        vm.tSourceCode_def = 'CRS_2A';
        vm.list.b_attach = false;

        vm.list.b_materie = false;
        vm.list.b_classi = false;

        //Filtro
        vm.filter = {};

        vm.fTestuale = '';
        vm.fTMisuraCode = '2A';
        vm.fPartecipazioneId = 0;
        vm.fAPLId = 0;
        vm.fIStato = 0;

        vm.filter.testuale = vm.fTestuale;
        vm.filter.tMisuraCode = vm.fTMisuraCode;
        vm.filter.partecipazioneId = vm.fPartecipazioneId;
        vm.filter.aplId = vm.fAPLId;
        vm.filter.iStato = vm.fIStato;

        vm.fAttach = {};
        vm.setfAttach = setfAttach;
        vm.filterAttach = '';
        vm.fAttach.TAttachId = '';

        //Elenchi per filtri e finestra modale di Create
        vm.tSource = {};
        vm.tAttach = [];

        vm.cmblist = {};

        vm.cmblist.APL = [];

        // #region Localizzazione

        vm.cmblist.paesi_sedeSvolg = [];
        vm.cmblist.province_sedeSvolg = [];
        vm.cmblist.comuni_sedeSvolg = [];
        vm.cmblist.tIndirizzi_sedeSvolg = [];

        //-- SedeSvolg_PaeseId, SedeSvolg_ComuneId
        vm.change_Paesi_Svolg = function () {
            if (vm.record.SedeSvolg_PaeseId > 0) {
                vm.record.SedeSvolg_ComuneId = 0;
                vm.record.SedeSvolg_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_Svolg = function (idProv) {
            vm.record.SedeSvolg_ComuneId = '';
            vm.getComuni_Svolg(idProv);
        };
        vm.getComuni_Svolg = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeSvolg = [];
            if (vm.record.SedeSvolg_ProvinciaId != idprov) vm.cmblist.comuni_sedeSvolg = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeSvolg = data;
            });
        };
        vm.getPaesi_Svolg = function () {
            if (vm.cmblist.paesi_sedeSvolg.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeSvolg = data;
            });
        };
        vm.getProvince_Svolg = function () {
            if (vm.cmblist.province_sedeSvolg.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_sedeSvolg = data;
            });
        };
        vm.getTIndirizzi_Svolg = function () {
            if (vm.cmblist.tIndirizzi_sedeSvolg.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeSvolg = data;
            });
        };

        //---------------------------

        vm.cmblist.paesi_sedeEsame = [];
        vm.cmblist.province_sedeEsame = [];
        vm.cmblist.comuni_sedeEsame = [];
        vm.cmblist.tIndirizzi_sedeEsame = [];

        //-- SedeEsame_PaeseId, SedeEsame_ComuneId
        vm.change_Paesi_Esame = function () {
            if (vm.record.SedeEsame_PaeseId > 0) {
                vm.record.SedeEsame_ComuneId = 0;
                vm.record.SedeEsame_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_Esame = function (idProv) {
            vm.record.SedeEsame_ComuneId = '';
            vm.getComuni_Esame(idProv);
        };
        vm.getComuni_Esame = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeEsame = [];
            if (vm.record.SedeEsame_ProvinciaId != idprov) vm.cmblist.comuni_sedeEsame = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeEsame = data;
            });
        };
        vm.getPaesi_Esame = function () {
            if (vm.cmblist.paesi_sedeEsame.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeEsame = data;
            });
        };
        vm.getProvince_Esame = function () {
            if (vm.cmblist.province_sedeEsame.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_sedeEsame = data;
            });
        };
        vm.getTIndirizzi_Esame = function () {
            if (vm.cmblist.tIndirizzi_sedeEsame.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeEsame = data;
            });
        };


        // #endregion

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.showList = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;


        vm.goNext = goNext;
        vm.goPrev = goPrev;
        vm.PrevWizard = PrevWizard;
        vm.NextWizard = NextWizard;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.merge = mergeItem;
        vm.delete = deleteItem;

        vm.minLenPIVA = 11;

        vm.stepCompiled = stepCompiled;

        vm.pageWizardTitle.push('1 - DATI PERCORSO');
        vm.pageWizardTitle.push('2 - SEDE SVOLGIMENTO PERCORSO');
        vm.pageWizardTitle.push('3 - SEDE DI ESAME ED ENTE CERTIFICATORE');
        vm.pageWizardTitle.push('4 - ARTICOLAZIONE ATTIVIT\xC0 FORMATIVA');
        vm.pageWizardTitle.push('5 - RIEPILOGO');


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            if (iOpened == 1) vm.opened1 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [
                getAuthorization()
                , getAPL()
                , getTSource(vm.tSourceCode_def)
                , getTAttach(vm.tSourceCode_def)
                //Localizzazioni 
                , vm.getPaesi_Svolg()
                , vm.getProvince_Svolg()
                , vm.getTIndirizzi_Svolg()
                , vm.getPaesi_Esame()
                , vm.getProvince_Esame()
                , vm.getTIndirizzi_Esame()
            ];
            common.activateController(promises, controllerId)
                .then(function () {

                    vm.back = 0;
                    if ($routeParams.back != null && $routeParams.cndPartId != null) {
                        vm.back = parseInt($routeParams.back);
                        vm.cndPartId = $routeParams.cndPartId;
                    }
                    
                    if ($routeParams.CNDPCorso2AId != null) {
                        setView('detail');
                        getRecord($routeParams.CNDPCorso2AId, 0);
                    }

                    if (!vm.isSpecial) {
                        cerca();
                    }
                        
                });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.activated = true;
            vm.showList = true;
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.tMisuraCode = vm.fTMisuraCode == null ? '' : vm.fTMisuraCode;
            vm.filter.partecipazioneId = vm.fPartecipazioneId == null ? 0 : vm.fPartecipazioneId;
            vm.filter.aplId = vm.fAPLId == null ? 0 : vm.fAPLId;
            vm.filter.iStato = vm.fIStato == null ? 0 : vm.fIStato;
            vm.filter.tMisuraCode = '2A';

            vm.loading = false;

            //Filtro no-show-list
            if (vm.isSpecial) {
                if (
                    (typeof vm.fTestuale == 'undefined' || vm.fTestuale.length < 3)
                    && vm.fIStato == 0
                    && (vm.fAPLId == 0 || vm.fAPLId == '' || vm.fAPLId == null)
                ) {
                    vm.showList = false;
                    return log("Attenzione: definire i criteri di ricerca (per il campo testuale minimo 3 caratteri), successivamente premere il pulsante 'AVVIA RICERCA'.");
                }
            }

            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.pCorso_countAll(vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.partecipazioneId, vm.filter.aplId, vm.filter.iStato).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.pCorso_getAll(vm.pageSize, vm.page, vm.filter.testuale, vm.filter.tMisuraCode, vm.filter.partecipazioneId, vm.filter.aplId, vm.filter.iStato, "").then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function (data) {
                //Auth. specifica
                //vm.isSpecial = (vm.isSUPER || vm.isUMC || vm.isCIAPI);
            });
        }


        function setRecord(data, pageWiz) {
            //console.info('setRecord()', data);
            vm.record = data;

            if (vm.record.SedeSvolg_TIndirizzoId == 0) vm.record.SedeSvolg_TIndirizzoId = 1;
            if (vm.record.SedeEsame_TIndirizzoId == 0) vm.record.SedeEsame_TIndirizzoId = 1;

            if ((vm.record.SedeSvolg_PaeseId == null || vm.record.SedeSvolg_PaeseId == 0)
                    && (vm.record.SedeSvolg_ComuneId == undefined || vm.record.SedeSvolg_ComuneId == null || vm.record.SedeSvolg_ComuneId == 0))
                vm.record.SedeSvolg_ComuneId = '';

            if ((vm.record.SedeEsame_PaeseId == null || vm.record.SedeEsame_PaeseId == 0)
                && (vm.record.SedeEsame_ComuneId == undefined || vm.record.SedeEsame_ComuneId == null || vm.record.SedeEsame_ComuneId == 0))
                vm.record.SedeEsame_ComuneId = '';

            vm.getComuni_Svolg(vm.record.SedeSvolg_ProvinciaId);
            vm.getComuni_Esame(vm.record.SedeEsame_ProvinciaId);
            vm.getModuloSummary(vm.record.PCMod);
            vm.record.PCModChanged = false;

            vm.validPIVA = true;
            vm.validCF = true;
            vm.bMaxOre = true;

            if (vm.record.EnteCertif_bEstero) {
                vm.minLenPIVA = 4;
            }
            else {
                vm.minLenPIVA = 11;
            }

            //Azzera filtri
            vm.list.attach = [];
            vm.list.b_attach = false;

            vm.filterAttach = '';
            vm.fAttach.TAttachId = '';

            // #region Gestione Wizard
            vm.wizardCompleted = false;
            vm.pageWizard = 1;
            vm.lastPageWizard = 1;

            if (pageWiz != null && pageWiz != '' && typeof pageWiz != 'undefined') { //Ho salvato in bozza
                vm.pageWizard = pageWiz;
            }

            /*
            if (vm.record.PCMod != null && vm.record.PCMod.length > 0) {
                vm.wizardCompleted = true;
            }
            */

            if (vm.record.Completed || vm.wizardCompleted) {
                vm.pageWizard = vm.pageMaxWizard;
                vm.lastPageWizard = vm.pageMaxWizard;
            }
            // #endregion
        }

        function getRecord(id, index) {
            return datacontext.pCorso_get(id).then(function (data) {
                vm.index = index;
                setRecord(data);
               
                setView('detail');
            });
        }

        function goNext() {
            if (vm.index + 1 >= vm.countRecords) return;
            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                getByFilter();
            }
            if (!vm.records) return;

            vm.index++;
            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        function goPrev() {
            if (vm.index == 0) return;
            if (!vm.records) return;

            vm.index--;

            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        // #region GESTIONE WIZARD
        function PrevWizard(recordForm) {
            if (vm.record.Completed && !vm.isSUPER)
                return;

            if (vm.pageWizard <= 1) return;
            vm.pageWizard--;

            return vm.pageWizard;
        }

        function NextWizard(recordForm) {
            if (typeof recordForm != 'undefined' || recordForm != null) {
                if (recordForm.$invalid) return;
            }
            if (vm.pageWizard >= vm.pageMaxWizard) return;

            
            vm.pageWizard++;
            vm.lastPageWizard = vm.pageWizard;

            if (vm.pageWizard == vm.pageMaxWizard)
                vm.wizardCompleted = true;



            return vm.pageWizard;
        }


        function setPageWizard(value) {
            if ((vm.record.Completed || !vm.stepCompiled(value)) && !vm.isSUPER )
                return;

            if (value > vm.lastPageWizard)
                return;

            vm.pageWizard = value;
        }

        function stepCompiled(value) {
            if (value < vm.pageWizard)
                return true;
            for (var locPageWizard = vm.pageWizard; locPageWizard < value; locPageWizard++) {
                var retVal = false;
                if (locPageWizard != 6) {
                    retVal = true;
                } else if (locPageWizard == 6) {
                    if (vm.record.PCMod.length > 0)
                        retVal = true;
                }
                
                if (!retVal)
                    return false;
            }
            return true;
        }

        // #endregion

        function addRecord(id) {
            vm.showList = true;
            return datacontext.pCorso_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {            
            return datacontext.pCorso_update(vm.record).then(function (data) {
                if ($.isNumeric(data)) {
                    if (data < 0) return parseInt(data); //Resistuisco un numero perch� il metodo � chiamato nelle variazioni di stato
                    else if (data == "400") {
                        logError('Si \xE8 verificato un errore. ');
                        return 400;
                    }
                    else if (data == "409") return logError('Errore! Nome Corso esistente!!');
                    else if (data == "406") return logError('Errore! Inserire tutti gli allegati richiesti!!');
                }

                setRecord(data);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function mergeItem() {
            return datacontext.pCorso_merge(vm.record).then(function (data) {
                if ($.isNumeric(data)) {
                    if (data < 0) return parseInt(data); //Resistuisco un numero perch� il metodo � chiamato nelle variazioni di stato
                    else if (data == "400") {
                        logError('Si \xE8 verificato un errore. ');
                        return 400;
                    }
                    else if (data == "409") return logError('Errore! Nome Corso esistente!!');
                    else if (data == "406") return logError('Errore! Inserire tutti gli allegati richiesti!!');
                }

                setRecord(data, vm.pageWizard);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function deleteItem(item) {
            var msg = ' Percorso: ' + item.NomeCorso;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pCorso_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;

                    return logSuccess('Record cancellato ');
                });
            });
        }

        vm.setCompleted = function () {
            if (!vm.record.Completed)
                bDialog.confirmationDialog('Salva e convalida', 'Attenzione, si sta "SALVANDO e CONVALIDANDO" il percorso. Successivamente, non sar\xE0 possibile apportare modifiche. Si desidera procedere?', 'Procedi').then(
                    function () { //YES
                        vm.record.Completed = true;
                        return mergeItem().then(function (data) {
                            if (typeof data == undefined || $.isNumeric(data)) {
                                vm.record.Completed = false;
                                if ($.isNumeric(data)) {
                                    var msg = 'Attenzione, si \xE8 verificato un errore che ha impedito il salvataggio, ';
                                    switch (data) {
                                        case -1:
                                            msg += 'alcuni campi necessari per la generazione dell\'allegato non sono stati compilati. ';
                                            break;
                                        case -11:
                                            msg += 'il numero di allievi deve essere compreso tra min 15 e max 20. ';
                                            break;
                                        case -12:
                                            msg += '\xE8 necessario inserire almeno un modulo. ';
                                            break;
                                        case -13:
                                            msg += '\xE8 necessario riempire i campi dell\'ente certificatore. ';
                                            break;
                                        case -14:
                                            msg += 'il numero di ore deve essere comprese tra min 50 e max 200. ';
                                            break;
                                        case -15:
                                            msg += 'la somma delle ore dei moduli differisce dalle ore totali del percorso. ';
                                            break;
                                    }
                                    return bDialog.informationDialog(msg);
                                }
                                if (data == "406")
                                    return logError('Attenzione: alcuni campi necessari per la generazione dell\'allegato non sono stati compilati. ');
                            }  
                        });
                    },
                    function () { //NO
                        //
                    }
                );
        };

        vm.unlock = function (item) {
            item = vm.record;
            var msg = 'Percorso ID:' + item.Id + ' - ' + item.NomeCorso;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare il ' + msg + ' ?', 'OK').then(
                function () { //YES
                    return datacontext.pCorso_unlock(item).then(function (data) {
                        if (data != "204") return logError('Errore: operazione non consentita');
                        vm.record.Completed = false;
                        vm.records[vm.index].Completed = vm.record.Completed;

                        return logSuccess('Record sbloccato ');
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        //Elenchi Parametri
        function getAPL() {
            return datacontext.azienda_getAllList('', '', 0, '', 'PROM', '2A', 0, 0, 0, '', '', '', 0).then(function (data) {
                return vm.cmblist.APL = data;
            });
        }


        // ENTE CERTIFICATORE
        vm.reset_EnteCertificatore = function () {
            if (!vm.record.bEnteCertificatore) {
                vm.record.EnteCertif_RagioneSociale = '';
                vm.record.EnteCertif_PIVA = '';
                vm.record.EnteCertif_CF = '';
            }
        };

        // #region Corso Modulo

        vm.addCorsoMod = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2A/modal/cndPModuloAdd2A.html?version=127',
                controller: 'cndPModuloAdd2A',
                backdrop: 'static',
                resolve: {
                    modulo: function () {
                        return item;
                    },
                    corsoId: function () {
                        return vm.record.Id;
                    },
                    opInsert: function () {
                        return vm.record.OpInsert;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {                
                if (!returnItem) return logError('Attenzione errore. ');

                if (typeof item == 'undefined') {
                    vm.record.PCMod.push(returnItem);
                }
                else {
                    var index = vm.record.PCMod.indexOf(item);
                    if (index !== -1) {
                        vm.record.PCMod[index] = returnItem;
                    }  
                }

                vm.getModuloSummary(vm.record.PCMod);
                vm.record.PCModChanged = true;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteCorsoMod = function (item) {
            item.Deleted = true;
            vm.record.PCModChanged = true;
            vm.getModuloSummary(vm.record.PCMod);
            return logSuccess('Elemento rimosso ');
        };

        vm.getModuloSummary = function (array) {
            vm.sumOreAula = 0;
            vm.sumOreLab = 0;
            vm.sumOreAltro = 0;
            vm.sumOreTotali = 0;

            if (typeof array == 'undefined' || array.length == 0)
                return;
            return array.forEach(function (item) {
                if (!item.Deleted) {
                    vm.sumOreAula += item.OreAula;
                    vm.sumOreLab += item.OreLaboratorio;
                    if (item.bAltro)
                        vm.sumOreAltro += item.OreAltro;
                    vm.sumOreTotali += item.TotOre;
                }

                return true;
            });
        };


        // #endregion

        // #region STAMPA ALLEGATO 4

        vm.printAllegato = function (index) {
            var msg = '';
            if (!vm.record.Completed) {
                msg = 'L\'allegato verr\xE0 stampato in bozza. Attenzione, se prima di stampare non si provvede al salvataggio dei dati inseriti ("SALVA IN BOZZA"), questi potrebbero non essere visualizzati nell\'allegato. Procedere? ';
            }
            else {
                msg = 'L\'allegato verr\xE0 stampato. Procedere? ';
            }
            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    vm.printing = true;
                    $('#loadingModal').modal('show');

                    return datacontext.pdf_printAttach2(0, vm.tSourceCode_def, vm.record.Id, 0, index).then(function (response) {
                        vm.printing = false;
                        $('#loadingModal').modal('hide');
                        var status = response.status;
                        var data = response.data;

                        if (response == null || $.isNumeric(status)) {
                            if (status == 417) {
                                return logError('Attenzione si \xE8 verificato il seguente problema: ' + data);
                            }
                            return logError('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                        }
                        else if (response && response.url) {

                            var url = response.url;
                            var name = 'Allegato4_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';

                            window.open(url, name);

                            //recupero allegato appena creato
                            //var a = document.createElement("a");
                            //a.setAttribute('style', 'display:none');
                            //a.setAttribute('target', '_blank');
                            //document.body.appendChild(a);

                            //a.href = response.url;
                            //if ($rootScope.detectIE()) {
                            //    a.target = 'hiddenIframe';
                            //}
                            //else
                            //    a.download = 'Allegato4_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';
                            //a.click();
                            //document.body.removeChild(a);

                            return response.url;
                        } else
                            return true;
                    });
                },
                function () { //NO
                    //
                }
            );    
        };

        // #endregion

        // #region PANNELLO ATTACH
        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }
        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getListAttach(id) {
            if (!id) return;

            if (vm.fAttach.TAttachId == '' || vm.fAttach.TAttachId == null || typeof vm.fAttach.TAttachId == 'undefined') {
                vm.fAttach.TAttachId = 0;
            }

            return datacontext.attach_getAll(0, 0, id, 0, vm.tSourceCode_def, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;

                return datacontext.tAttachVisibility_getAuth(vm.tSourceCode_def).then(function (data_TAV) {
                    var tAttVis = data_TAV;

                    vm.list.attach.forEach(function (item_A) {
                        var myTAV = _.find(tAttVis, { 'TAttachId': item_A.TAttachId });

                        if (typeof myTAV == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        item_A.bRead = myTAV.bRead;
                        item_A.bInsert = myTAV.bInsert;
                        item_A.bUpdate = myTAV.bUpdate;
                        item_A.bDelete = myTAV.bDelete;
                        item_A.iTags = myTAV.iTags;

                        if (!item_A.bRead) {
                            var index = vm.list.attach.indexOf(item_A);
                            vm.list.attach.splice(index, 1);
                        }

                    });

                    return vm.list.attach = data;
                });
            });
        }

        vm.addAttach = function (item) {
            //console.info('item', item);
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.NomeCorso };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd.html?version=127',
                controller: 'attachAdd',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        var tatt = typeof item == 'undefined' ? null : vm.tAttach;
                        return tatt;
                    },
                    tAttachId: function () {
                        var tattid = typeof item == 'undefined' ? null : item.TAttachId;
                        return tattid;
                    },
                    attach: function () {
                        return item;
                    },
                    anomalia: function () {
                        return false;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "417") return logError('Attenzione: entit\xE0 bloccata. ');
                if (returnItem == "401") return logError('Attenzione: azione non autorizzata. ');
                if (returnItem == "406") return logError('Attenzione: allegato non permesso. ');
                if (returnItem == "409") return logError('Attenzione: allegato alterato rispetto all\'originale. ');
                if ($.isNumeric(returnItem)) return logError('Attenzione: errore generico. ');
                //Documenti con hashcode diverso da originale ma non bloccante
                if (returnItem.alert != null) { bDialog.informationDialog(returnItem.alert); }

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);

            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteAttach = function (item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: entit\xE0 bloccata. ');
                    if (data == "401") return logError('Attenzione: azione non autorizzata. ');
                    if (data == "404") return logError('Attenzione: entit\xE0 inesistente. ');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                });
            });
        };


        // #endregion


        vm.change_enteCertif = function () {
            if (!vm.record.bEnteCertificatore) {
                vm.record.EnteCertif_RagioneSociale = '';
                vm.record.EnteCertif_bEstero = false;
                vm.record.EnteCertif_PIVA = '';
                vm.record.EnteCertif_CF = '';
                vm.record.EnteCertif_Abilitato = false;
            }
        }

        vm.change_enteCertifEstero = function () {
            if (!vm.record.EnteCertif_bEstero) {
                vm.minLenPIVA = 11;
                if (vm.record.EnteCertif_PIVA != null &&
                    vm.record.EnteCertif_PIVA != '' &&
                    typeof vm.record.EnteCertif_PIVA != 'undefined' &&
                    vm.record.EnteCertif_PIVA.length > 0) {
                    vm.checkPIVA(vm.record.EnteCertif_PIVA);
                }
                if (vm.record.EnteCertif_CF != null &&
                    vm.record.EnteCertif_CF != '' &&
                    typeof vm.record.EnteCertif_CF != 'undefined' &&
                    vm.record.EnteCertif_CF.length > 0) {
                    vm.checkCF(vm.record.EnteCertif_CF);
                }
            }
            else {
                vm.minLenPIVA = 4;
                vm.validPIVA = true;
            }
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPCorsi2A/modal/cndPCorsoAdd2A.html?version=127',
                controller: 'cndPCorsoAdd2A',
                backdrop: 'static',
                resolve: {
                    apl: function () {
                        return vm.cmblist.APL;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                if (returnItem == "409") return logError('Errore! Nome Corso esistente!');
                if (!returnItem) return logError('errore di creazione! ');

                logSuccess('record creato con successo! ');
                addRecord(returnItem.Id);
                
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        
        // #region VERIFICA PARTITA IVA E CODICE FISCALE

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.checkPIVA = function (value) {
            vm.validPIVA = true;
            if (!vm.record.EnteCertif_bEstero) {                
                if (value == undefined) return;
                if (value.length != 11) return; //numero minimo di caratteri  
                vm.validPIVA = false;
                return datacontext.validazione_piva(value, false).then(function (data) {
                    return vm.validPIVA = data;
                });
            }
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        
        vm.checkCF = function (value) {
            vm.validCF = true;
            var isEnte = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) {
                vm.validCF = true;
                return; //numero minimo di caratteri  
            }            
            if (value.length == 11) isEnte = true;
            vm.validCF = false;
            return datacontext.validazione_cf(value, isEnte).then(function (data) {
                return vm.validCF = data;
            });
        };

        // #endregion

    }
})();
